
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import MapModelMixin from './mixins/MapModelMixin'
import UnitModel from '../models/UnitModel'

class UnitCollection extends Backbone.Collection {
  
  model(attrs, options) {
    return new UnitModel(attrs, options)
  }

  color(color) {
    this.each(model => model.color(color))
    return this
  }

  data() {
    let retval = []
    this.each(model => retval.push(model.data()))
    return retval
  }
}

Cocktail.mixin(UnitCollection, MapModelMixin)

export default UnitCollection
